module.exports = __webpack_public_path__ + "img/3-top.045d875b.png";